
define("Wax/get!view-templates/pitchByPitch/pitchByPitch",["Wax/Wax"],function(Wax){return Wax.register("view-templates/pitchByPitch/pitchByPitch",'{{> pitchesView}}\n{{> eventsView}}');});
